import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './WithSelectCompactDisplay.module.css';

const bindClasses = classNameBind.bind(styles);

const WithSelectCompactDisplay = (Component) => {
  const HOC = ({ type, ...props }) => (
    <div className={bindClasses(type)}>
      <Component type={type} {...props} />
    </div>
  );

  HOC.defaultProps = {
    type: '',
  };

  return HOC;
};

export { WithSelectCompactDisplay };
